var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.784 12.6333C38.7083 14.8633 36.3674 17.7267 36.3664 19.9995C36.3654 22.355 38.6713 25.2232 37.784 27.3666C36.8967 29.5091 33.2374 29.907 31.5727 31.5737C29.9664 33.181 29.5966 36.8607 27.3667 37.784C25.1367 38.7083 22.2733 36.3674 20.0005 36.3664C17.645 36.3654 14.7767 38.6713 12.6334 37.784C10.4909 36.8966 10.093 33.2374 8.42634 31.5727C6.81903 29.9664 3.13935 29.5966 2.21602 27.3666C1.29172 25.1367 3.63263 22.2733 3.6336 20.0005C3.63457 17.645 1.3287 14.7767 2.21602 12.6333C3.10335 10.4909 6.7626 10.093 8.42731 8.42631C10.0336 6.819 10.4034 3.13935 12.6334 2.21602C14.8633 1.29172 17.7267 3.63263 19.9995 3.6336C22.355 3.63458 25.2233 1.32869 27.3667 2.21602C29.5091 3.10335 29.907 6.76257 31.5737 8.42728C33.181 10.0336 36.8607 10.4033 37.784 12.6333Z",
    stroke: "#131313",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 26.25L26.25 13.75",
    stroke: "#131313",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4167 18.3333C17.0275 18.3333 18.3333 17.0275 18.3333 15.4167C18.3333 13.8058 17.0275 12.5 15.4167 12.5C13.8058 12.5 12.5 13.8058 12.5 15.4167C12.5 17.0275 13.8058 18.3333 15.4167 18.3333Z",
    fill: "#131313"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5866 27.5C26.1975 27.5 27.5033 26.1942 27.5033 24.5833C27.5033 22.9725 26.1975 21.6667 24.5866 21.6667C22.9758 21.6667 21.67 22.9725 21.67 24.5833C21.67 26.1942 22.9758 27.5 24.5866 27.5Z",
    fill: "#131313"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountIcon);
export default __webpack_public_path__ + "static/media/discount-icon.ef809e1e4fced0f7096fd70e418b73d9.svg";
export { ForwardRef as ReactComponent };